import { render, staticRenderFns } from "./searchResultBlock.vue?vue&type=template&id=62505f46&scoped=true&"
import script from "./searchResultBlock.vue?vue&type=script&lang=js&"
export * from "./searchResultBlock.vue?vue&type=script&lang=js&"
import style0 from "./searchResultBlock.vue?vue&type=style&index=0&id=62505f46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62505f46",
  null
  
)

export default component.exports